import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getWarehouseCategoryList,
	addNewWarehouseCategory,
	updateWarehouseCategory,
	deleteWarehouseCategory,
	getWarehouseCategory,
	checkWarehouseCategoryExists
} from '../warehouseCategory/thunk';

export const initialState = {
	itemWarehouseCategoryList: [],
	itemWarehouseCategory: null,
	isWarehouseCategoryLoading: false,
	isWarehouseCategorySuccess: false,

	dataWarehouseCategory: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false
};

const WarehouseCategorySlice = createSlice({
	name: 'WarehouseCategory',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		}
	},
	extraReducers: builder => {
		builder.addCase(getWarehouseCategory.fulfilled, (state, action) => {
			state.isWarehouseCategoryLoading = false;
			state.isWarehouseCategorySuccess = true;
			state.itemWarehouseCategory = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getWarehouseCategory.pending, state => {
			state.isWarehouseCategoryLoading = true;
			state.isWarehouseCategorySuccess = null;
			state.itemWarehouseCategory = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getWarehouseCategory.rejected, (state, action) => {
			state.isWarehouseCategoryLoading = false;
			state.isWarehouseCategorySuccess = false;
			state.itemWarehouseCategory = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getWarehouseCategoryList.pending, state => {
			state.isWarehouseCategorySuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getWarehouseCategoryList.fulfilled, (state, action) => {
			state.itemWarehouseCategoryList = action.payload;
			state.statementList = action.payload;
			state.isLoadingList = false;
			state.isWarehouseCategorySuccess = true;

			let statementListSelect = [];
			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.statementListSelect = statementListSelect;
		});
		builder.addCase(getWarehouseCategoryList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWarehouseCategorySuccess = true;
		});
		builder.addCase(addNewWarehouseCategory.fulfilled, (state, action) => {
			state.itemWarehouseCategoryList.push(action.payload);
			state.statementList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewWarehouseCategory.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewWarehouseCategory.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateWarehouseCategory.fulfilled, (state, action) => {
			state.itemWarehouseCategoryList = state.itemWarehouseCategoryList.map(warehouseCategoryList =>
				warehouseCategoryList._id.toString() === action.payload._id.toString()
					? { ...warehouseCategoryList, ...action.payload}
					: warehouseCategoryList
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateWarehouseCategory.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateWarehouseCategory.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWarehouseCategory.fulfilled, (state, action) => {
			state.itemWarehouseCategoryList = current(state.itemWarehouseCategoryList).filter(
				item => item._id !== action.payload._id
			);
			state.statementList = current(state.statementList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteWarehouseCategory.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteWarehouseCategory.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		builder.addCase(checkWarehouseCategoryExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});
		builder.addCase(checkWarehouseCategoryExists.pending, (state, action) => {
			state.exists = false;
		});
		builder.addCase(checkWarehouseCategoryExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const {
	setRequireCloseModal
} = WarehouseCategorySlice.actions;

export default WarehouseCategorySlice.reducer;